<template lang="pug">
  div.tag-search
    div.statistic
      label(:class="type") {{$route.params.tag}}
      span(v-html="statistic")
    div.result
      report-item(:list="reports")
      event-item(:list="events")
</template>

<script>
import ReportItem from './ReportItem'
import EventItem from './EventItem'
export default {
  name: 'TagSearch',
  components: {
    ReportItem,
    EventItem
  },
  data () {
    return {
      statistic: `共检索到<span style="color: #f87653;">1</span>份报告，<span style="color: #f87653;">3</span>个危机`,
      type: 'category',
      reports: [
        {
          img: require('@index/assets/img/rank/滴滴出行.png'),
          title: '网传“滴滴司机”直播性侵',
          context: '6月10日，有网络传闻称，有滴滴司机对乘客进行性侵，并进行了直播。滴滴官方迅速做出回应，通过官方微博@滴滴出行 表示：“我们已关注到网传“滴滴司机性侵直播”的信息，我们已报警并正在紧急核实，一旦有进展会向社会公众及时公开。”',
          startTime: '2020/04/27',
          brand: '滴滴',
          category: '谣言',
          score: 77.1,
          report: '132313asdadasdasdada',
          isCollect: false,
          type: '人事'
        }
      ],
      events: [
        {
          img: require('@index/assets/img/rank/滴滴出行.png'),
          title: '网传“滴滴司机”直播性侵',
          context: '6月10日，有网络传闻称，有滴滴司机对乘客进行性侵，并进行了直播。滴滴官方迅速做出回应，通过官方微博@滴滴出行 表示：“我们已关注到网传“滴滴司机性侵直播”的信息，我们已报警并正在紧急核实，一旦有进展会向社会公众及时公开。”',
          startTime: '2020/04/27',
          brand: '滴滴',
          category: '谣言',
          score: 77.1,
          report: '132313asdadasdasdada',
          isCollect: false,
          type: '人事'
        },
        {
          img: require('@index/assets/img/rank/滴滴出行.png'),
          title: '网传“滴滴司机”直播性侵',
          context: '6月10日，有网络传闻称，有滴滴司机对乘客进行性侵，并进行了直播。滴滴官方迅速做出回应，通过官方微博@滴滴出行 表示：“我们已关注到网传“滴滴司机性侵直播”的信息，我们已报警并正在紧急核实，一旦有进展会向社会公众及时公开。”',
          startTime: '2020/04/27',
          brand: '滴滴',
          category: '谣言',
          score: 77.1,
          report: '132313asdadasdasdada',
          isCollect: false,
          type: '人事'
        },
        {
          img: require('@index/assets/img/rank/滴滴出行.png'),
          title: '网传“滴滴司机”直播性侵',
          context: '6月10日，有网络传闻称，有滴滴司机对乘客进行性侵，并进行了直播。滴滴官方迅速做出回应，通过官方微博@滴滴出行 表示：“我们已关注到网传“滴滴司机性侵直播”的信息，我们已报警并正在紧急核实，一旦有进展会向社会公众及时公开。”',
          startTime: '2020/04/27',
          brand: '滴滴',
          category: '谣言',
          score: 77.1,
          report: '132313asdadasdasdada',
          isCollect: false,
          type: '人事'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .tag-search{
    .statistic{
      padding: 24px;
      background: #fff;
      border-radius: 4px;
      font-weight: bold;
      font-size: 16px;
      label{
        padding: 3px 6px;
        border-radius: 2px;
        cursor: pointer;
        font-size: 12px;
        margin-right: 14px;
        &.brand{
          background-color: #fef1ed;
          color: #f87653;
          border: solid 1px #f87653;
          margin-right: 10px;
        }
        &.category{
          background-color: #ebf3fa;
          color: #3989cb;
          border: solid 1px #3989cb;
        }
      }
    }
    .result{
      margin: 4px 0 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/TagSearch.vue